import React from 'react'
import { Button, Card, Col, Drawer, Form, notification, Row } from 'antd'
import GetEachFormFields from '../../../components/_utils/appFormUtils'
import { formItemLayout } from '../../../components/_utils/appUtils'
import { useDispatch } from 'react-redux'
import { changePassword } from '../actions'

const ChangePasswordDrawer = (props) => {
  let dispatch = useDispatch()
  let { visible, onClose, userId, form, onSubmitSuccess } = props
  let { getFieldDecorator } = form

  const inputSchema = {
    fields: [
      {
        label: 'Current Password',
        placeholder: 'Current Password',
        key: 'currentPassword',
        required: true
      },
      {
        label: 'New Password',
        placeholder: 'New Password',
        key: 'password',
        required: true
      },
      {
        label: 'Confirm Password',
        placeholder: 'Confirm Password',
        key: 'confirmPassword',
        required: true
      }
    ]
  }

  const handleSubmit = e => {
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        if (valData.password !== valData.confirmPassword) {
          notification.error({
            message: 'Confirm Password does not match new password'
          })
        } else {
          valData._id = userId
          let resp = await dispatch(changePassword(valData))
          if (resp && !resp.error) {
            form.resetFields()
            if (onSubmitSuccess) {
              onSubmitSuccess()
            } else {
              onClose()
            }
          }
        }
      } else {
        notification.error({
          message: 'Please enter all required fields.'
        })
      }
    })
  }

  return (
    <Drawer
      title='Change Password'
      width={'40%'}
      visible={visible}
      placement='right'
      onClose={onClose}>
      <Card>
        <Form onSubmit={handleSubmit} hideRequiredMark className={'inputForm'}>
          <Row gutter={16}>
            {inputSchema.fields.map((item, key) => {
              return (
                <Col span={24} key={key}>
                  <GetEachFormFields
                    getFieldDecorator={getFieldDecorator}
                    item={item}
                    formItemLayout={formItemLayout}
                  />
                </Col>
              )
            })}
            <Col span={24}>
              <Form.Item style={{ marginTop: 40 }}>
                <Button type='primary' htmlType='submit'>
                  Submit
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    </Drawer>
  )
}

const WrappedChangePasswordDrawer = Form.create()(ChangePasswordDrawer)
export default WrappedChangePasswordDrawer
